// MealPreferencesExportButton.jsx
import React from "react";
import jsPDF from "jspdf";
import autoTable from "jspdf-autotable";

const DAYS = ["monday","tuesday","wednesday","thursday","friday","saturday","sunday"];
const DAY_LABELS = {
  monday: "Montag",
  tuesday: "Dienstag",
  wednesday: "Mittwoch",
  thursday: "Donnerstag",
  friday: "Freitag",
  saturday: "Samstag",
  sunday: "Sonntag",
};

export default function MealPreferencesExportButton({
  patients = [],
  disabled = false,
  className = "",
  filenamePrefix = "essenspraeferenzen",
  title = "Essenspräferenzen (Woche)",
}) {
  function exportToPdf() {
    if (disabled) return;
    if (!Array.isArray(patients) || patients.length === 0) return;

    const doc = new jsPDF({ orientation: "landscape", unit: "pt", format: "a4" });

    doc.setFontSize(16);
    doc.text(title, 40, 40);

    const head = [["Patient", ...DAYS.map(d => DAY_LABELS[d])]];
    const body = patients.map((p) => {
      const row = [p.name || `Patient ${p.id}`];
      for (const d of DAYS) {
        const val = p.preferences?.[d] ?? "—";
        const isNone = !val || String(val).toLowerCase() === "none";
        row.push(isNone ? "—" : String(val));
      }
      return row;
    });

    autoTable(doc, {
      startY: 70,
      head,
      body,
      styles: { fontSize: 9, cellPadding: 6 },
    });

    const now = new Date();
    const yyyy = now.getFullYear();
    const mm = String(now.getMonth() + 1).padStart(2, "0");
    const dd = String(now.getDate()).padStart(2, "0");
    doc.save(`${filenamePrefix}_${yyyy}-${mm}-${dd}.pdf`);
  }

  return (
    <button
      type="button"
      onClick={exportToPdf}
      disabled={disabled || !patients?.length}
      className={[
        "rounded-xl bg-white px-4 py-2 text-sm font-semibold text-gray-900",
        "shadow-sm border border-black/10 hover:bg-white/70 disabled:opacity-60",
        className,
      ].join(" ")}
    >
      Export PDF
    </button>
  );
}